export default defineNuxtPlugin(() => {
  let env: 'dev' | 'uat' | 'prod'
  const hostname = window.location.hostname
  if (/uat\.glodastory\.com/.test(hostname))
    env = 'uat'
  else if (/glodastory\.com/.test(hostname))
    env = 'prod'
  else
    env = 'dev'

  return {
    provide: {
      env,
    },
  }
})
